import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  ButtonGroup,
  Glyphicon
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {getCharityList, deleteCharity, charityStatus} from '../../../redux/actions/charityActions';
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import moment from "moment";
import AffiliateDashboard from "../../affiliate/dashboard";
import {
  renderAlert,
  clearAlert
} from "../../../redux/actions/alertsActions";
import Dialog from "react-bootstrap-dialog";
import "../../../style/listPage.scss";
import {aclUtil} from "../../util";
import Toggle from "react-bootstrap-toggle";

const history = createBrowserHistory();
let isLoading = "false";
class CharityList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'LIST_CHARITY',
      charityList: [],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      legal_nameSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      account_nameSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      emailSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      deal_citySortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      registeredOnSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      path: ["Home", "Manage Charity List"],
      links: ["home", "charity/list"],
      show: false,
      direction: "",
      orderBy: ""
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSelect(limit) {
    this.setState({
      limit: limit
    });
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search
    };

    this.props.getCharityList(postData);
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: "1",
      limit: this.state.limit,
      search: searchstring
    };

    if (this.state.search.length !== 0) {
      this.props.getCharityList(postData);
    } else {
      this.props.getCharityList({ page: this.state.currentPage,limit: this.state.limit });
    }
  }

  handleSort = orderBy => e => {
    e.preventDefault();

    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getCharityList({ orderBy: orderBy, direction: direction,limit: this.state.limit });
  };

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    const postData = {
      page: page,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : ""
    };
    this.props.getCharityList(postData);
  };

  componentWillMount() {
    isLoading = "true";
    this.handleDismiss();
    this.props.clearAlert();
    this.props.getCharityList({ page: this.state.currentPage,limit: this.state.limit });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.charityList !== nextProps.charityList) {
      if (nextProps.charityList) {
        const setPageCount =
          nextProps.charityList.total / nextProps.charityList.per_page;
        this.setState({
          charityList: nextProps.charityList.data,
          totalRecords: nextProps.charityList.total,
          perPage: nextProps.charityList.per_page,
          pageCount: setPageCount
        });
        isLoading = "false";
      }
    }

    if (this.props.deleteStatus !== nextProps.deleteStatus) {
      if (!isEmpty(nextProps.deleteStatus)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.deleteStatus.message);
        isLoading = "false";
        this.props.getCharityList({ page: this.state.currentPage,limit: this.state.limit });
        window.scrollTo(0, 0);
      }
    }

    if (this.props.status !== nextProps.status) {
      if (!isEmpty(nextProps.status)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.status.message);
        isLoading = "false";
        this.props.getCharityList({ page: this.state.currentPage,limit: this.state.limit });
        window.scrollTo(0, 0);
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }
  }

  handleDelete = charityID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(charityID);
          this.handleShow();
        })
      ]
    });
  };

  confirmDelete = charityID => {
    isLoading = "true";
    this.props.deleteCharity(charityID);
  };

  handleClick = (e, id, charityStatus) => {
    this.dialog.show({
      body: "Are you sure you want to change charity status?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmStatus(e, id, charityStatus);
          this.handleShow();
        })
      ]
    });
  };

  confirmStatus = (e, id, charityStatus) => {
    isLoading = "true";
    if(charityStatus === 'active'){
      this.props.charityStatus({
        id: id,
        status: 'inactive',
      });
    }else{
      this.props.charityStatus({
        id: id,
        status: 'active',
      });
    }
  };

  redirectDashboard = affiliateID => {
    if (affiliateID) {
    }
  };

  redirectToWebSite = websiteUrl => {
    if (websiteUrl !== "http://") {
      var win = window.open(websiteUrl, "_blank");
      win.focus();
    }
  };

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let charityRow;
    let charityListData = this.state.charityList
      ? this.state.charityList
      : [];

    if (!isEmpty(charityListData)) {
      charityRow = charityListData.map((charity, index) => (
        <tr key={charity.charity_id}>
          <td>{charity.charity_name}</td>
          <td>{charity.email}</td>
          <td>{charity.phone}</td>
          {aclUtil.checkACL('CHARITY_STATUS') ? (<td>
            <Toggle
              on={"Active"}
              off={"Inactive"}
              size="lg"
              responsive="true"
              offstyle="default"
              onstyle="success"
              height="30px"
              width="100px"
              active={(charity.status === 'active') ? true : false}
              onClick={e => {
                this.handleClick(e, charity.charity_id, charity.status);
              }}
            />
          </td>):("")}
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('CHARITY_EDIT') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/edit-charity-setting/${charity.charity_id}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>):("")}
                  {aclUtil.checkACL('CHARITY_DELETE') ? (<MenuItem eventKey={Math.random()} onClick={this.handleDelete.bind(this, charity.charity_id)}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }else{
      charityRow = <tr><td colSpan='5'>Data Not Found</td></tr>
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="col-lg-12 list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading panel-heading-index">
              <div className="row">
                <div className="col-lg-6 col-md-4 col-sm-12">
                  <h4>Charity List</h4>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" name="search" onKeyUp={this.handleSearch} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-12">
                  {aclUtil.checkACL('ADD_CHARITY') ? (
                    <Button className="addMerchant"
                      bsSize="small"
                      bsStyle="success"
                      onClick={() => this.context.router.history.push("/charity-setting")}
                    >
                      + Add Charity
                    </Button>)
                    : ("")}
                </div>
              </div>
            </header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th onClick={this.handleSort("account_name")}>
                          Charity Title{" "}
                          <i className={this.state.account_nameSortIcon} />
                        </th>
                        <th onClick={this.handleSort("email")}>
                          Email <i className={this.state.emailSortIcon} />
                        </th>
                        <th>Phone</th>
                        {aclUtil.checkACL('CHARITY_STATUS') ? (<th>Status</th>):("")}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>{charityRow}</tbody>
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button className="btn btn-default"
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CharityList.propTypes = {
  getCharityList: PropTypes.func.isRequired,
  deleteCharity: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  charityList: state.charityReducer.charityList,
  status: state.charityReducer.status,
  deleteStatus: state.charityReducer.deleteStatus,
  error: state.charityReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default connect(mapStateToProps, {
  getCharityList,
  deleteCharity,
  charityStatus,
  renderAlert,
  clearAlert
})(CharityList);



// WEBPACK FOOTER //
// ./src/app/views/admin/charity/CharityList.js